import React from "react";

export interface EyebrowProps {
  children: React.ReactNode;
  /** Leading signage tick — a short lit dash before the label. */
  tick?: boolean;
  /** Center the eyebrow (hero/marquee headers). */
  centered?: boolean;
  className?: string;
}

/**
 * The station-sign kicker of the Night Marquee header system: JetBrains Mono,
 * wide-tracked uppercase, amber — used above every page and section title so
 * headers read like lit transit signage instead of three competing styles.
 */
const Eyebrow: React.FC<EyebrowProps> = ({
  children,
  tick = true,
  centered = false,
  className = "",
}) => (
  <p
    className={`flex items-center gap-3 font-mono text-xs font-medium uppercase tracking-[0.3em] text-accent-400 ${
      centered ? "justify-center" : ""
    } ${className}`}
  >
    {tick && (
      <span
        aria-hidden
        className="h-px w-6 shrink-0 bg-gradient-to-r from-accent-400/0 via-accent-400/80 to-accent-400"
      />
    )}
    <span>{children}</span>
    {tick && centered && (
      <span
        aria-hidden
        className="h-px w-6 shrink-0 bg-gradient-to-l from-accent-400/0 via-accent-400/80 to-accent-400"
      />
    )}
  </p>
);

export default Eyebrow;
